<template>
  <div class="content">
    <div class="header">
      <div class="title">
        <p>委托检测信息确认单</p>
      </div>
      <div class="normal-text right-align">
        <p>委托编号：{{contract_data.project_display_no}}</p>
      </div>
    </div>
    <vue-qr class="qr-img" :text="qrUrl" v-show="false"></vue-qr>
    <div class="company normal-text">
      <div class="half-section">
        <p><span class="bold-text1">委托方：</span>{{contract_data.customer.customerCompany.name}}</p>
        <p>（甲方）</p>
        <p>地址/邮编：{{contract_data.customer.customerCompany.address}}</p>
        <p>电话/传真：{{contract_data.customer.customerCompany.telephone}}{{contract_data.customer.customerCompany.fax?('/'+contract_data.customer.customerCompany.fax):''}}</p>
      </div>
    </div>
    <div class="ins-content">
      <div class="normal-text">
        <p><span class="bold-text1">样品及检测信息</span></p>
        <div class="two-date">
          <p>委托送检日期：{{contract_data.apply_date}}</p>
          <p>约定完成日期：{{contract_data.reportInfo.completeDate}}<span v-if="contract_data.reportInfo.agentMark!=='正常'" style="padding-left:5pt;font-weight:600;">({{contract_data.reportInfo.agentMark}})</span></p>
        </div>
      </div>
      <div class="loop-sample-wrapper">
        <div class="sample-item" v-for="(sa,index) in contract_data.sample" :key="sa.name+index">
          <div class="sample-info">
            <p class="sample-name"><span class="info-label">样品名称：</span>{{sa.name}}</p>
            <p v-if="sa.model" class="sample-model"><span class="info-label">样品型号：</span>{{sa.model?sa.model:'/'}}</p>
            <p v-if="sa.property" class="sample-property"><span class="info-label">样品属性：</span>{{sa.property?sa.property:'/'}}</p>
            <p class="sample-amount"><span class="info-label">样品数量：</span>{{sa.amount}}</p>
          </div>
          <div class="test-items">
            <div v-for="(one,subindex) in sa.testItems" :key="subindex" class="test-item">
              <div class="test-item-content">
                <div class="test-item-text">{{one.choice.text}}</div>
                <div class="test-item-amount">{{one.amount}}{{one.choice.unit?one.choice.unit:''}}</div>
                <div v-if="one.remark" class="test-item-remark">备注：{{one.remark}}</div>
              </div>
              <div v-if="one.params" class="test-item-params">
                <span v-for="(param,index) in one.params" :key="index+'params'">{{param.title}}:{{param.choosed}};</span>
              </div>
            </div>
          </div>
          <!-- 分割线，区分不同样品 -->
          <div v-if="index < contract_data.sample.length - 1" class="sample-divider"></div>
        </div>
      </div>
      <div class="des small-text" v-if="contract_data.remark&&contract_data.remark.customer">
        <p class="Kaiti-text1">备注：{{contract_data.remark.customer}}</p>
      </div>
    </div>
    <div class="des small-text">
      <div class="des-l">
        <p class="bold-text1">约定事项</p>
        <div class="des-l-c">
          <p>1.甲方对其试样信息的真实性负责；乙方仅对来样负责。</p>
          <p>2.乙方仅对来样按检测标准出具检测数据，不作检定结论及符合性判断。</p>
          <p>3.甲方应在领取检测报告前结清全部检测费用。</p>
          <p>4.试样截取 &nbsp;&nbsp;{{contract_data.reportInfo.samplePosition}}</p>
          <p>5.检测方法 &nbsp;&nbsp;{{contract_data.reportInfo.testMethod}}</p>
          <p>6.检测分包 &nbsp;&nbsp;{{contract_data.reportInfo.ifSubpackage}}</p>
          <p>7.报告编制 &nbsp;&nbsp;{{contract_data.reportInfo.reportStyle}}</p>
          <p>8.报告领取 &nbsp;&nbsp;{{contract_data.reportInfo.reportDelivery}}</p>
          <p>9.余样处置 &nbsp;&nbsp;{{contract_data.reportInfo.restSample}}</p>
        </div>
      </div>
      <div class="des-r">
        <p v-if="contract_data.remark&&contract_data.remark.sample_valid!==undefined">收到的样品是否符合检测标准要求：</p>
        <p v-if="contract_data.remark&&contract_data.remark.sample_valid!==undefined">{{(contract_data.remark&&contract_data.remark.sample_valid)?'☑':'☐'}}符合</p>
        <p v-if="contract_data.remark&&contract_data.remark.sample_valid!==undefined">{{(contract_data.remark&&contract_data.remark.sample_valid)?'☐':'☑'}}不符合</p>
        <p>检测服务费：<span class="bold-text1">&nbsp;￥{{contract_data.totalPrice}}</span>&nbsp;元</p>
        <p>注：以上检测服务费为含税价格，税率均为6%（增值税专用发票或增值税普通发票）</p>
        <p>账户名称：上海轨道交通检测认证（集团）有限公司</p>
        <p>银行账号：7559 4391 0410 501</p>
        <p>开户银行：招商银行上海江苏路支行</p>
      </div>
    </div>
  </div>
</template>

<script>
let authData = JSON.parse(localStorage.getItem("authData"));

import vueQr from "vue-qr";

export default {
  name: "contractPageOld",
  props: {
    contract_data: {
      type: Object
    },
    totalPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 0
    }
  },
  components: {
    vueQr
  },
  data() {
    return {
      qrImgUrl: process.env.BASE_URL + "img/reportCoverPageLogo.jpg"
    };
  },
  methods: {
    generateString(tmpList, property_name = "text", delimit_icon = ",") {
      let resList = [];
      for (let i of tmpList) {
        resList.push(i[property_name]);
      }
      return resList.join(delimit_icon);
    },
    padStart(str, char, len) {
      if (str.length >= len) {
        return str;
      } else {
        let tmpList = new Array(len - str.length).fill(char);
        return tmpList.join("") + str;
      }
    }
  },
  computed: {
    qrUrl: function() {
      return this.$m_url + "s_i/" + this.contract_data.project_display_no;
    },
    signUrl: function() {
      return this.$fileUrlFac(
        this.contract_data.signature_url,
        authData.sfileRight
      );
    }
  }
};
</script>

<style scoped>
.content {
  width: 100%;
  color: #000;
  text-align: left;
  padding: 10px;
  box-sizing: border-box;
}

.header {
  margin-bottom: 20px;
}

.header-info {
  font-size: 12px;
  font-family: Times New Roman;
}

.title {
  text-align: center;
  font-size: 18px;
  font-family: KaiTi;
  font-weight: 600;
  margin: 10px 0;
}

.normal-text {
  font-size: 14px;
}

.small-text {
  font-size: 12px;
}

.bold-text1 {
  font-size: 16px;
  font-weight: 600;
}

.company {
  border-bottom: 1px solid #222;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.half-section {
  width: 100%;
}

.ins-content {
  margin: 20px 0;
}

.two-date {
  margin-bottom: 10px;
}

.des {
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
  padding: 10px 0;
  margin: 20px 0;
}

.des-l {
  width: 100%;
  margin-bottom: 20px;
}

.des-l-c {
  text-indent: 1em;
}

.des-r {
  width: 100%;
}

.loop-sample-wrapper {
  margin: 10px 0;
}

.sample-item {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f9f9f9;
}

.sample-info {
  margin-bottom: 10px;
}

.sample-name, .sample-model, .sample-property, .sample-amount {
  font-size: 11px;
  margin-bottom: 5px;
}

.info-label {
  font-weight: 600;
  color: #333;
}

.test-items {
  display: flex;
  flex-direction: column;
}

.test-item {
  margin-bottom: 5px;
  padding: 5px;
  background-color: #fff;
}

.test-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
}

.test-item-text {
  flex: 1;
  margin-right: 10px;
}

.test-item-amount {
  flex: 0 0 80px; /* 加宽宽度，避免换行 */
  text-align: right;
  white-space: nowrap; /* 防止换行 */
}

.test-item-remark {
  font-size: 10px;
  color: #888;
  margin-top: 5px;
}

.test-item-params {
  font-size: 10px;
  color: #666;
  margin-top: 5px;
  padding-top: 5px;
}

.sample-divider {
  height: 1px;
  background-color: #ddd;
  margin: 10px 0;
}

.qr-img {
  display: none;
}

.Kaiti-text1 {
  font-family: "KaiTi";
  font-size: 14px;
}
</style>